import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Button,
  Modal,
  Alert,
  Spinner,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import { useDispatch } from "react-redux";
import GridRecentWork from "./recentWorkList";
import AddRecentWork from "./AddRecentWork";
import { getRecentWork, deleteRecentWork } from "../../../../slices/thunk";
import { useTranslation } from "react-i18next";


interface RecentWorkListProps {
  contractorId: any;
}
const RecentWorkList: React.FC<RecentWorkListProps> = ({ contractorId }) => {
  const dispatch = useDispatch<any>();
  const [listGrid, setListGrid] = useState<any>([]);
  const [addRecentWork, setAddRecentWork] = useState<boolean>(false);
  const [loading, setLoading] = useState<any>(false);
  const [deletingId, setDeletingId] = useState<any>(null);
  const [notification, setNotification] = useState<{
    status: boolean;
    message: string;
    variant: "success" | "danger" | "warning" | "info";
  } | null>(null);
  const { t } = useTranslation(); // ✅ React knows to update


  //Add Recent Work modal
  const handleShowRecentWork = () => setAddRecentWork(true);
  const handleCloseRecentWork = () => setAddRecentWork(false);

  useEffect(() => {
    dispatch(getRecentWork()).then((resp: any) => {
      setListGrid(resp?.result||[]);
    });
  }, [dispatch]);

  const handleRecentSuccess = (successStatus: any) => {
    if (successStatus) {
      dispatch(getRecentWork()).then((resp: any) => {
        setListGrid(resp?.result||[]);
        setAddRecentWork(false);
      });
    }
  };

  const handleDeleteRecentWork = async (id: any) => {
    setDeletingId(id);
    try {
      await dispatch(deleteRecentWork(id));
      const resp = await dispatch(getRecentWork());
      setListGrid(resp?.result||[]);
      setNotification({
        status: true,
        message: "Recent Work Deleted Successfully",
        variant: "success",
      });
    } catch (error) {
      console.error("Error deleting recent work:", error);
      setNotification({
        status: true,
        message: "Failed to delete recent work",
        variant: "danger",
      });
    } finally {
      setDeletingId(null);
    }
  };
  const handleAlertClick = () => {
    setNotification(null);
  };
  return (
    <React.Fragment>
    {notification && notification.status && (
      <div
        style={{
          position: "absolute",
          top: "5%",
          right: "24px",
          zIndex: 99999,
        }}
      >
        <Alert variant={notification.variant} onClick={handleAlertClick}>
          {t(notification.message)}
        </Alert>
      </div>
    )}
    {loading ? (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "200px" }}
      >
        <Spinner animation="border" role="status">
          <span className="visually-hidden">{t("Loading...")}</span>
        </Spinner>
      </div>
    ) : (
      <Row className="recent-work-section">
        <Col lg={12}>
          <Card className="profile-settings-content-card recent-work-shell-card">
            <Card.Body>
              <div className="recent-work-toolbar">
                <div>
                  <Card.Title as="h6" className="recent-work-title">
                    {t("Recent Work")}
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id="tooltip-top">
                          {t("Please enter details of your recent work so homeowners can review your previous projects.")}
                        </Tooltip>
                      }
                    >
                      <Button className="infoButton">?</Button>
                    </OverlayTrigger>
                  </Card.Title>
                </div>

                <Button variant="secondary" onClick={handleShowRecentWork}>
                  <i className="bi bi-plus-lg align-baseline me-1"></i> {t("Add Work")}
                </Button>
              </div>
            </Card.Body>
          </Card>
          <GridRecentWork
            data={listGrid}
            handleDelete={handleDeleteRecentWork}
            deletingId={deletingId}
          />
        </Col>
      </Row>
    )}
    <Modal show={addRecentWork} onHide={handleCloseRecentWork} size="lg" centered dialogClassName="recent-work-modal">
      <Modal.Header closeButton>
        <Modal.Title as="h5" id="addPropertyModalLabel">
          {t("Add Recent Work")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <AddRecentWork
          contractorId={contractorId}
          handleSucces={handleRecentSuccess}
        />
      </Modal.Body>
      <Modal.Footer>
        <div className="hstack gap-2 justify-content-end">
          <Button
            className="btn btn-ghost-danger"
            onClick={handleCloseRecentWork}
          >
            <i className="bi bi-x-lg align-baseline me-1"></i> {t("Close")}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  </React.Fragment>

  );
};

export default RecentWorkList;
